// @flow
import type { DataLoaderParams } from '../../../types/DataLoaderParams';
import { fetchSellersIfNeeded } from '../../../redux/modules/seller';
import { recordAnalyticsForFlattenTheCurvePageView } from '../../../redux/modules/analytics';

export default ({ match, store }: DataLoaderParams) => {
    const { params } = match;
    const { dispatch } = store;

    const sellerId = Number(params.sellerId);

    return Promise.all([dispatch(fetchSellersIfNeeded([sellerId]))]).then(() => {
        return dispatch(recordAnalyticsForFlattenTheCurvePageView());
    });
};
